import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import Button, { ButtonType, ButtonTheme, ButtonSize } from '../../atoms/button/button';
import { IconType, IconSize } from '../../atoms/icon/icon';
import './formFooter.scss';
import Checkbox from '../../atoms/checkbox/checkbox';

const FormFooter = (props) => {
  const {
    id, type, theme, size, onClick, onBlur, children, icon, iconColor, iconSize, disabled, propagate,floatPosition
  } = props;

  const childRef = useRef();
  const [propagateState, setPropate] = useState(false);

  const handleChangeCheckbox = () => {
    setPropate(!propagateState);
  };

  if (childRef.current) {
    childRef.current.updateValue(propagateState);
  }

  return (
    <div className={"footer-button " + (floatPosition?"float"+floatPosition:"floatright")}>
      <div className="px-3 pb-3 clearfix">
        <Button
          id={id}
          // className={floatPosition?"float"+floatPosition:"float-right"}
          type={type}
          onClick={() => onClick(propagateState)}
          onBlur={onBlur}
          disabled={disabled}
          icon={icon}
          iconSize={iconSize}
          iconColor={iconColor}
          theme={theme}
          size={size}
        >
          {children}
        </Button>
        { propagate
        && (
          <Checkbox
            className="d-inline"
            ref={childRef}
            onChange={handleChangeCheckbox}
          >
            Propagate changes
          </Checkbox>
        )}
      </div>
    </div>
  );
};

FormFooter.propTypes = {
  /**
   * Id of save button
   */
  id: PropTypes.string,
  /**
   * HTML attribute type
   */
  type: PropTypes.oneOf(Object.values(ButtonType)),
  /**
   * Button background color
   */
  theme: PropTypes.oneOf(Object.values(ButtonTheme)),
  /**
   * Button general size
   */
  size: PropTypes.oneOf(Object.values(ButtonSize)),
  /**
   * Function to bind click HTML functionality
   */
  onClick: PropTypes.func,
  /**
   * Function to bind onBlur HTML functionality
   */
  onBlur: PropTypes.func,
  /**
   * Content to put inside the Button component
   */
  children: PropTypes.node,
  /**
   * To select a icon inside the button
   */
  icon: PropTypes.oneOf(Object.values(IconType)),
  /**
   * Icon color inside the button
   */
  iconColor: PropTypes.string,
  /**
   * Icon size inside the button
   */
  iconSize: PropTypes.oneOf(Object.values(IconSize)),
  /**
   * To disable the button functionality
   */
  disabled: PropTypes.bool,
  /**
   * To enable propagate button
   */
  propagate: PropTypes.bool,
};

FormFooter.defaultProps = {
  id:'',
  type: ButtonType.BUTTON,
  theme: ButtonTheme.PRIMARY,
  size: ButtonSize.SMALL,
  onClick: () => {},
  onBlur: () => {},
  children: null,
  icon: '',
  iconColor: '',
  iconSize: IconSize.SMALL,
  disabled: false,
  propagate: false,
};

export default FormFooter;
